import React from 'react'
import { Box, Container } from '@mui/material'
import NextImage from 'next/image'
import { useTranslation } from 'next-i18next'
import { Breakpoint } from '@mui/system'

// import NavNextLink from '@/components/EMT/NavNextLink'
import { Routes } from '@/assets/configs'
// import { useIsQueryOwner } from '@/hooks'
import VariantImages from '@/assets/VariantImages'
import useRouter from 'next/router'
import useCurrentUser from '@/hooks/useCurrentUser'

import {
  // EmtChip,
  EmtIcon,
  EmtTypography,
} from 'emt-components-v2'
import { TokenKeys } from '@/modules/Auth/LocalStorageHelper'
import { openUrlApp } from '@/utils/utils'

enum ActiveItem {
  Dashboard = 'dashboard',
  Search = 'search',
  Reservations = 'reservations',
  NewRequest = 'newRequest',
}

interface Props {
  containerMaxWidth?: Breakpoint | false
}

const PetSittingNav: React.FC<Props> = ({ containerMaxWidth = 'lg' }) => {
  const { t } = useTranslation('petsitter')
  // const [, , appendQueryType] = useIsQueryOwner()
  const router = useRouter
  const { tendersEnabled } = useCurrentUser()

  // TODO:
  // const badge = 3

  let activeItem: ActiveItem | null = null
  switch (router.pathname) {
    // case Routes.PetSitter.Base:
    //   activeItem = ActiveItem.Dashboard
    //   break
    case Routes.PetSitter.Search:
      activeItem = ActiveItem.Search
      break
    case Routes.PetSitter.Reservations.NewRequest:
      activeItem = ActiveItem.NewRequest
      break

    case Routes.PetSitter.Reservations.Base:
    case Routes.PetSitter.Reservations.Payment:
      activeItem = ActiveItem.Reservations
      break
    default:
      break
  }

  return (
    <Box
      sx={{
        height: '68px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'purple.600',
      }}
    >
      <Container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          height: '100%',
        }}
        maxWidth={containerMaxWidth}
      >
        <NextImage width={100} src={VariantImages.PetSitter} alt={'petsitter'} style={{ alignSelf: 'center' }} />
        <Box
          sx={{
            display: 'flex',
            gap: '30px',
          }}
        >
          {/* <NavNextLink
            sx={{
              borderTop: '6px solid transparent',
              borderBottom: activeItem === ActiveItem.Dashboard ? '6px solid #762D8A' : '6px solid transparent',
              '& p, .emt-icons, p>span': {
                color: activeItem === ActiveItem.Dashboard ? '#762D8A!important' : '#fff!important',
              },
              '&:hover': {
                '& p, .emt-icons, p>span': {
                  color: '#762D8A!important',
                },
              },
            }}
            href={appendQueryType(Routes.PetSitter.Base)}
          >
            <EmtIcon
              className="emt-book-1"
              sx={{
                fontSize: '16px',
              }}
            />
            <EmtTypography variant="body2" fontWeight="bold">
              {t('navigation.dashboard')}
            </EmtTypography>
          </NavNextLink> */}
          {!tendersEnabled && (
            <Box
              sx={{
                borderTop: '6px solid transparent',
                borderBottom: activeItem === ActiveItem.Search ? '6px solid #762D8A' : '6px solid transparent',
                '& p, .emt-icons, p>span': {
                  color: activeItem === ActiveItem.Search ? '#762D8A!important' : '#fff!important',
                },
                '&:hover': {
                  '& p, .emt-icons, p>span': {
                    color: '#762D8A!important',
                  },
                },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                cursor: 'pointer',
              }}
              onClick={(e) => {
                e.preventDefault()
                const url = `https://app.supersitters.app/pet-sitter/search?token=${encodeURIComponent(
                  localStorage.getItem(TokenKeys.Auth ?? '') || '',
                )}&refreshToken=${encodeURIComponent(
                  localStorage.getItem(TokenKeys.Refresh ?? '') || '',
                )}&type=dogowner`
                openUrlApp(url)
              }}
            >
              {/* <NavNextLink
                sx={{
                  borderTop: '6px solid transparent',
                  borderBottom: activeItem === ActiveItem.Search ? '6px solid #762D8A' : '6px solid transparent',
                  '& p, .emt-icons, p>span': {
                    color: activeItem === ActiveItem.Search ? '#762D8A!important' : '#fff!important',
                  },
                  '&:hover': {
                    '& p, .emt-icons, p>span': {
                      color: '#762D8A!important',
                    },
                  },
                }}
                href={appendQueryType(Routes.PetSitter.Search)}
              > */}
              <EmtIcon
                className="emt-search-1"
                sx={{
                  fontSize: '16px',
                }}
              />
              <EmtTypography variant="body2" fontWeight="bold">
                {t('navigation.search')}
              </EmtTypography>
              {/* </NavNextLink> */}
            </Box>
          )}
          {tendersEnabled && (
            <Box
              sx={{
                borderTop: '6px solid transparent',
                borderBottom: activeItem === ActiveItem.NewRequest ? '6px solid #762D8A' : '6px solid transparent',
                '& p, .emt-icons, p>span': {
                  color: activeItem === ActiveItem.NewRequest ? '#762D8A!important' : '#fff!important',
                },
                '&:hover': {
                  '& p, .emt-icons, p>span': {
                    color: '#762D8A!important',
                  },
                },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                cursor: 'pointer',
              }}
              onClick={(e) => {
                e.preventDefault()
                const url = `https://app.supersitters.app/pet-sitter/reservations/new-request?token=${encodeURIComponent(
                  localStorage.getItem(TokenKeys.Auth ?? '') || '',
                )}&refreshToken=${encodeURIComponent(
                  localStorage.getItem(TokenKeys.Refresh ?? '') || '',
                )}&type=dogowner`
                openUrlApp(url)
              }}
            >
              {/* <NavNextLink
                sx={{
                  borderTop: '6px solid transparent',
                  borderBottom: activeItem === ActiveItem.NewRequest ? '6px solid #762D8A' : '6px solid transparent',
                  '& p, .emt-icons, p>span': {
                    color: activeItem === ActiveItem.NewRequest ? '#762D8A!important' : '#fff!important',
                  },
                  '&:hover': {
                    '& p, .emt-icons, p>span': {
                      color: '#762D8A!important',
                    },
                  },
                }}
                href={
                  appendQueryType(Routes.PetSitter.Reservations.NewRequest)

                  `https://app.supersitters.app/?type=dogowner&token=${encodeURIComponent(
                    localStorage.getItem(TokenKeys.Auth ?? '') || '',
                  )}&refreshToken=${encodeURIComponent(localStorage.getItem(TokenKeys.Refresh ?? '') || '')}`
                }
              > */}
              <EmtIcon
                className="emt-add"
                sx={{
                  fontSize: '16px',
                }}
              />
              <EmtTypography variant="body2" fontWeight="bold">
                {t('navigation.newReservation')}
              </EmtTypography>
              {/* </NavNextLink> */}
            </Box>
          )}
          <Box
            sx={{
              borderTop: '6px solid transparent',
              borderBottom: activeItem === ActiveItem.Reservations ? '6px solid #762D8A' : '6px solid transparent',
              '& p, .emt-icons, p>span': {
                color: activeItem === ActiveItem.Reservations ? '#762D8A!important' : '#fff!important',
              },
              '&:hover': {
                '& p, .emt-icons, p>span': {
                  color: '#762D8A!important',
                },
              },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              cursor: 'pointer',
            }}
            onClick={(e) => {
              e.preventDefault()
              const url = `https://app.supersitters.app/pet-sitter/reservations?token=${encodeURIComponent(
                localStorage.getItem(TokenKeys.Auth ?? '') || '',
              )}&refreshToken=${encodeURIComponent(localStorage.getItem(TokenKeys.Refresh ?? '') || '')}&type=dogowner`
              openUrlApp(url)
            }}
          >
            {/* <NavNextLink
              sx={{
                borderTop: '6px solid transparent',
                borderBottom: activeItem === ActiveItem.Reservations ? '6px solid #762D8A' : '6px solid transparent',
                '& p, .emt-icons, p>span': {
                  color: activeItem === ActiveItem.Reservations ? '#762D8A!important' : '#fff!important',
                },
                '&:hover': {
                  '& p, .emt-icons, p>span': {
                    color: '#762D8A!important',
                  },
                  '& .MuiChip-label': {
                    color: '#fff!important',
                  },
                },
              }}
              href={
                appendQueryType(Routes.PetSitter.Reservations.Base)

                `https://app.supersitters.app/?type=dogowner&token=${encodeURIComponent(
                  localStorage.getItem(TokenKeys.Auth ?? '') || '',
                )}&refreshToken=${encodeURIComponent(localStorage.getItem(TokenKeys.Refresh ?? '') || '')}`
              }
            > */}
            <EmtIcon
              className="emt-message-text-alt-1"
              sx={{
                fontSize: '16px',
              }}
            />
            <EmtTypography variant="body2" fontWeight="bold">
              {t('navigation.messagerie')}
            </EmtTypography>
            {/* {!!badge && (
              <EmtChip
                color="purple"
                type="roundedNumber"
                label={badge}
                sx={{ backgroundColor: '#762D8A', '& span': { color: '#fff!important', paddingTop: '1px' } }}
              />
            )} */}
            {/* </NavNextLink> */}
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default PetSittingNav
